import styles from "./TourListFilter.module.css";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Input from "../common/input/Input";
import { useAppStore } from "../../hooks/store/useAppStore";
import { tourFilterSelector } from "../../hooks/store/getters";
import { setTourFilterSelector } from "../../hooks/store/setters";
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { MdViewModule, MdPlace } from "react-icons/md";

const sortByOptions = [
    {
        label: "tour name",
        value: "tourName",
    },
    {
        label: "location",
        value: "tourCountry",
    },
]

const TourListFilter = ({ toggleMapView, isMapView }) => {
    const tourFilter = useAppStore(tourFilterSelector);
    const setTourFilter = useAppStore(setTourFilterSelector);
    
    const handleSearchInput = ({ target: { name, value } }) => {
        setTourFilter( { [name]: value })
    }
    
    const ViewTypeBtn = ({ icon, isActive, type }) => {
        
        return (
            <OverlayTrigger
                placement="top"
                overlay={ <Tooltip>{ type }</Tooltip> }
            >
                <Button 
                    variant={isActive ? 'light' : 'outline-light'} 
                    onClick={() => !isActive ? toggleMapView() : null}
                >
                    { icon }
                </Button>
            </OverlayTrigger>
        )
    }
    
    return (
        <div className={styles.TourListFilter}>
            <Row className="w-100">
                <Col md={5} sm={12}>
                   <Input
                        variant="dark"
                        placeholder="Search users, tours, etc"
                        name="search"
                        value={tourFilter.search}
                        onChange={(e) => handleSearchInput(e)}
                    />
                </Col>

                <Col md={2} sm={6} xs={6}>
                    <Input type="select"
                        variant="dark"
                        placeholder="Sort By"
                        name="sort"
                        value={tourFilter.sortBy}
                        options={sortByOptions}
                        onChange={(e) => handleSearchInput(e)}
                    />
                </Col>
                <Col>
                    <div className={styles.listViews}>
                        <ViewTypeBtn icon={<MdPlace />} 
                            isActive={isMapView} 
                            type="Map View" 
                        />
                        <ViewTypeBtn icon={<MdViewModule />}
                            isActive={!isMapView} 
                            type="List View" 
                        />
                    </div>
                </Col>
            </Row>
        </div>
    )
};

export default TourListFilter;
